// extracted by mini-css-extract-plugin
export default {"contentWrap":"NoticePage_contentWrap__wnxzO"};